module.exports = __webpack_public_path__ + "media/images/mastercard-4d408a986a6d8fa2bd78479d71f1c30c.png";